import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useLocation, useNavigate } from "react-router-dom"
import {
    Button,
    Card,
    CardBody,
    Col,
    FormGroup,
    Input,
    Label,
    Row,
} from "reactstrap"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import breadcrumbs from "../../../common/Breadcrumbs"
import { routes } from "routes/path"
import FeedbackTable from "./FeedbackTable"

function Feedback() {
    const { deleteApi, postApi, getApi } = useApi()
    const { state } = useLocation()
    const navigate = useNavigate()
    let { pathname } = useLocation()
    const [tableData, setTableData] = useState([])
    const [questionList, setQuestionList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [rowsPerPage, setRowsPerPage] = useState(20)
    const [remark, setRemark] = useState("")
    const [displayStart, setDisplayStart] = useState(1)

    const getTableData = () => {
        setIsLoading(true)
        getApi("FeedBack/list", '').then(({ data, status }) => {
            if (status === 200) {
                const activeData = data
                    .filter(item => item.IsActive === true && item.GroupType == state.GroupType)
                    .map(item => ({
                        ...item,
                        Rating: 0,
                    }));
                setIsLoading(false);
                setTableData(activeData);
            } else {
                setIsLoading(false)
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }

    useEffect(() => {
        getTableData()
    }, [])

    const handleInputChange = (rowIndex, QuestionId, value) => {
        const updatedData = [...tableData];
        const currentRow = updatedData[rowIndex];

        const newValue = currentRow?.Rating === value ? null : value;

        updatedData[rowIndex] = {
            ...currentRow,
            Rating: newValue,
            FeedbackQuestionId: QuestionId,
            BookingId: state?.data?.Id,
            Remarks: ''
        };
        setTableData(updatedData);

        const filteredData = updatedData.filter(row => row?.Rating != 0);
        setQuestionList(filteredData);
    };

    const columns = useMemo(
        () => [
            {
                Header: "Question",
                accessor: "Question",
            },
            {
                Header: "EXCELLENT",
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        EXCELLENT
                    </div>
                ),
                accessor: "Excellent",
                width: "10%",
                Cell: ({ row }) => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        <FormGroup check>
                            <Input
                                type="checkbox"
                                defaultChecked={row.original?.Rating === 4}
                                onChange={() => handleInputChange(row.index, row.original.Id, 4)}
                            />
                        </FormGroup>
                    </div>
                ),
            },
            {
                Header: "GOOD",
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        GOOD
                    </div>
                ),
                accessor: "Good",
                width: "10%",
                Cell: ({ row }) => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        <FormGroup check>
                            <Input
                                type="checkbox"
                                defaultChecked={row.original?.Rating === 3}
                                onChange={() => handleInputChange(row.index, row.original.Id, 3)}
                            />
                        </FormGroup>
                    </div>
                ),
            },
            {
                Header: "AVERAGE",
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        AVERAGE
                    </div>
                ),
                accessor: "Average",
                width: "10%",
                Cell: ({ row }) => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        <FormGroup check>
                            <Input
                                type="checkbox"
                                defaultChecked={row.original?.Rating === 2}
                                onChange={() => handleInputChange(row.index, row.original.Id, 2)}
                            />
                        </FormGroup>
                    </div>
                ),
            },
            {
                Header: "POOR",
                Header: () => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        POOR
                    </div>
                ),
                accessor: "Poor",
                width: "10%",
                Cell: ({ row }) => (
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center"
                    }}
                    >
                        <FormGroup check>
                            <Input
                                type="checkbox"
                                defaultChecked={row.original?.Rating === 1}
                                onChange={() => handleInputChange(row.index, row.original.Id, 1)}
                            />
                        </FormGroup>
                    </div>
                ),
            },
        ],
        [tableData]
    )

    const handleSubmitFeedbackData = () => {
        if (questionList.length == 0) {
            toast.error("Feedback must include at least one question.", {
                style: {
                    fontSize: "15px",
                },
            })
        } else {
            questionList[0].Remarks = remark || ''
            setformSumitLoading(true)
            postApi("FeedBack/create",
                {
                    groupType: state?.GroupType,
                    feedbackQuestionList: questionList
                }
            ).then(({ data, status }) => {
                if (status === 200) {
                    setformSumitLoading(false)
                    navigate(state?.GroupType == 1 ? routes.bookingList : routes.delivery   )
                    toast.success("Sucessfully created", {
                        style: {
                            fontSize: "15px",
                        },
                    })
                } else {
                    setformSumitLoading(false)
                    toast.error(data, {
                        style: {
                            fontSize: "15px",
                        },
                    })
                }
            })
        }
    }
    const handleCancel = () => {
        navigate(routes.bookingList)
    }

    document.title = `Feedback | ${localStorage.getItem("ShopName")}`

    return (
        <div className="page-content">
            <div className="container-fluid">
                {isLoading && (
                    <div className="loading-overlay is-active">
                        <span className="fas fa-spinner fa-3x fa-spin"></span>
                    </div>
                )}
                <Breadcrumbs
                    title={breadcrumbs[pathname].title}
                    breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
                />
                <Card>
                    <CardBody>
                        <div>
                            <h2 style={{ display: "flex", justifyContent: "center", fontSize: "35px", fontWeight: "600", color: "#892a2a" }}>FEEDBAKE FORM</h2>
                            <hr
                                style={{
                                    background: "#00000036",
                                    height: "0.5px",
                                    margin: "0px",
                                    marginBottom: "15px",
                                }}
                            />
                            <h2 style={{ display: 'flex', justifyContent: "center", fontFamily: "cursive", color: "#bb7979", fontSize: "33px" }}>
                                We'd love to hear your thoughts
                            </h2>
                            <div style={{ fontSize: "22px", display: "flex", justifyContent: "center", marginTop: "20px", fontFamily: "'Font Awesome 5 Free'" }}>
                                Thank you for visiting at Raja-Rani Couture! Your opinion always motivates us to deliver the finest outfits.
                            </div>
                            <div style={{ fontSize: "22px", display: "flex", justifyContent: "center", marginTop: "5px", fontFamily: "'Font Awesome 5 Free'" }}>
                                Therefor, we'd like you to kindly fill out the feedbakc from hear
                            </div>
                        </div>
                        <Row className="text-center mt-4">
                            <Col md={5} style={{ fontSize: "18px" }}>
                                <span style={{ fontWeight: "500" }}>Customer Name:</span> <span>{state?.data?.Name}</span>
                            </Col>
                        </Row>
                        <Row className="text-center">
                            <Col md={4} style={{ fontSize: "18px" }}>
                                <span style={{ fontWeight: "500" }}>Mobile: </span> <span>{state?.data?.ContactNo1}</span>
                            </Col>
                            <Col md={6} style={{ fontSize: "18px" }}>
                                <span style={{ fontWeight: "500" }}>Your Purchase: </span> <span>{state?.data?.BillNo}</span>
                            </Col>
                        </Row>
                        <Row className="text-center mt-4">
                            <hr
                                style={{
                                    background: "#00000036",
                                    height: "0.5px",
                                    margin: "0px",
                                    marginBottom: "8px",
                                }}
                            />
                            <h3 style={{ fontWeight: "600", fontSize: "23px" }} >Please Tick Mark your Answers</h3>
                            <hr
                                style={{
                                    background: "#00000036",
                                    height: "0.5px",
                                    margin: "0px",
                                    marginBottom: "15px",
                                }}
                            />
                        </Row>
                        <FeedbackTable
                            columns={columns}
                            data={tableData}
                            isLoading={isLoading}
                            className="custom-header-css"
                        />
                        <Row>
                            <FormGroup className="mb-2 mt-2">
                                <Label htmlFor="validationCustom03" className="" style={{ fontSize: "20px" }}>
                                    Is thare something you want to ask? or share? Please share your thoughts below.
                                </Label>
                                <Input
                                    name="remark"
                                    placeholder="enter thoughts..."
                                    type="textarea"
                                    rows="4"
                                    className="form-control-sm"
                                    value={remark}
                                    onChange={(e) => { setRemark(e.target.value) }}
                                // onChange={validation.handleChange}
                                // onBlur={validation.handleBlur}
                                // value={validation.values.Name || ""}
                                />
                            </FormGroup>
                        </Row>
                        <Row>
                            <div style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
                                <Button
                                    color="secondary"
                                    className="btn btn-primary"
                                    onClick={() => handleCancel()}
                                >
                                    Cancel
                                </Button>
                                {formSumitLoading ? (
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                    >
                                        <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                        Loading
                                    </button>
                                ) : (
                                    <Button
                                        color="primary"
                                        className="btn btn-primary"
                                        // type="submit"
                                        onClick={() => handleSubmitFeedbackData()}
                                    >
                                        Submit
                                    </Button>
                                )}
                            </div>
                        </Row>
                    </CardBody>
                </Card>

            </div>
        </div>
    )
}
Feedback.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
}

export default Feedback
